<template>
	<edge-edit-bar @option-set="optionSet"></edge-edit-bar>
	<edge-edit-template v-if="isBarTemplateActive"></edge-edit-template>
	<edge-edit-design v-if="isEdgeDesignActive"></edge-edit-design>
	<edge-edit-visibility
		:blocked="edgeEditing"
		v-if="isEdgeBarVisibilityActive"
	></edge-edit-visibility>
	<edge-edit-content
		:blocked="edgeEditing"
		v-if="isEdgeBarContentActive"
	></edge-edit-content>
</template>

<script>
import EdgeEditBar from './modules/EdgeEditBar';
import {useStore} from 'vuex';
import {computed, ref} from 'vue';
import EdgeEditVisibility from './modules/EdgeEditVisibility';
import EdgeEditContent from './modules/EdgeEditContent';
import {EDGE_EDIT_BAR_OPTIONS} from '@/models/edit-bar/EDGE_EDIT_BAR_OPTIONS';
import EdgeEditDesign from './modules/EdgeEditDesign';
import EdgeEditTemplate from "./modules/EdgeEditTemplate";
export default {
	components: {EdgeEditTemplate, EdgeEditDesign, EdgeEditContent, EdgeEditVisibility, EdgeEditBar},
	setup() {
		const store = useStore();
		
		const optionActive = ref(null);
		function optionSet(option){
			optionActive.value = optionActive.value === option ? null : option;
		}
		
		const currentEdge = computed(() => store.getters['edges/getSelectedEdge']);
		const edgeEditing = computed(() => currentEdge.value.editing);
		
		const isEdgeDesignActive = computed(() => optionActive.value === EDGE_EDIT_BAR_OPTIONS.DESIGN_SETTINGS.VALUE);
		const isEdgeBarVisibilityActive = computed(() => optionActive.value === EDGE_EDIT_BAR_OPTIONS.VISIBILITY.VALUE);
		const isEdgeBarContentActive = computed(() => optionActive.value === EDGE_EDIT_BAR_OPTIONS.CONTENT.VALUE);
		
		// TEMPLATE
		const TEMPLATE_OPTION = {VALUE: 'TEMPLATE', TYPE: 'TEMPLATE', ICON: null, ACTION: null};
		const isBarTemplateActive = computed(() => optionActive.value === TEMPLATE_OPTION.VALUE);
		
		return {
			optionSet,
			isEdgeDesignActive,
			isEdgeBarVisibilityActive,
			isEdgeBarContentActive,
			isBarTemplateActive,
			edgeEditing,
		}
	}
}
</script>

<style lang="scss">

</style>
